import React, { useState, useEffect } from "react";
import {
  createStyles,
  Theme,
  makeStyles,
  createTheme,
} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { Link, Route } from "react-router-dom";
import logo from "../../assets/logo.png";
import { useHistory, useParams, useLocation } from "react-router-dom";
import AuthService from "../../services/auth";
import UserService from "../../services/user-service";
import "../../styling/sidebar.css";
import Box from "@material-ui/core/Box";
import ListItemButton from "@mui/material/ListItemButton";
import { Popover } from "react-bootstrap";
import Button from "@mui/material/Button";
import { ReactComponent as HomePic } from "../../assets/sidebaricons/blackhome.svg";
import { ReactComponent as LogoutPic } from "../../assets/sidebaricons/logoutgray.svg";
import { useSelector, useDispatch } from "react-redux";
import * as FaIcons from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import lightLogo from "../../assets/largelogoLight.png";
import { withStyles } from "@material-ui/core/styles";
import MaterialTooltip from "@material-ui/core/Tooltip";
import cs from "classnames";
import { ReactComponent as BugPic } from "../../assets/sidebaricons/bugIcon.svg";
import { themModeSelector } from "../../redux/selectors/AuthSelectors";
import { setUserInfo } from "../../redux/actions/AuthAction";
import "../../styling/table.css";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textAlign: "center",
      position: "relative",
    },
    drawer: {
      textAlign: "center",
    },
    drawerPaper: {
      backgroundColor: "white",
      width: "16.67%",
      textAlign: "center",
    },
    logoBox: {
      display: "flex",
      justifyContent: "center",
    },
    leftspace: {
      paddingLeft: 66,
    },
    arrowleft: {
      width: "100%",
      paddingTop: 20,
      paddingLeft: 35,
      "@media(max-width: 1025px)": {
        width: "23.9vw",
      },
    },
    openSidebar: {
      left: "-100%",
    },
    closeSidebar: {
      left: "0",
    },
    homeIcon: {
      minWidth: 31,
      marginBottom: 6,
    },
    bugLogo: {
      position: "absolute",
      bottom: 50,
      width: "16vw",
      color: "#7B7B7B",
      "@media(max-width: 1025px)": {
        width: "24vw",
      },
    },
    bottomlogout: {
      position: "absolute",
      bottom: 0,
      width: "16vw",
      color: "#7B7B7B",
      "@media(max-width: 1025px)": {
        width: "24vw",
      },
    },
    logout: {
      paddingLeft: 38,
    },
    darkModeIcon: {
      "& svg": {
        stroke: "#fff",
      },
    },
    // necessary for content to be below app bar
  })
);

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "black",
    boxShadow: theme.shadows[12],
    fontSize: 16,
    width: 120,
    height: 80,
    textAlign: "center",
    cursor: "default",
  },
  arrow: {
    color: "white",
  },
}))(MaterialTooltip);

interface PermanentDrawerLeftProps {
  sidebar?: boolean;
  setSidebar?: (any) => void;
  isTutorial?: boolean | undefined;
  setCheckEtsySource?: (any) => void;
  checkEtsySource?: boolean;
  completeTutorial?: boolean;
  setCompleteTutorial?: (any) => void;
}

const PermanentDrawerLeft: React.FC<PermanentDrawerLeftProps> = ({
  sidebar = false,
  setSidebar,
  isTutorial = false,
  setCheckEtsySource,
  checkEtsySource,
  completeTutorial = false,
  setCompleteTutorial,
}) => {
  const classes = useStyles();
  const text = {
    "font-weight": "bold",
  };
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [currLoading, setCurrLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const { isDarkMode } = useSelector(themModeSelector);
  const inames = [
    "The Antique Hunter",
    "Cameron’s Jewelry Shop",
    "Cameron’s Closet",
  ];

  const handleLogout = () => {
    AuthService.logout();
    history.push("/");
    //console.log('test109');
  };

  const handleLogo = () => {
    history.push("/");
  };

  useEffect(() => {
    UserService.getIncome().then((response) => {
      setCurrLoading(false);
    });
    UserService.getUserName().then((response) => {
      setFirstName(response.data.firstName);
      setLastName(response.data.lastName);
      dispatch(setUserInfo(response.data));
    });
  }, []);

  const handleEtsySource = () => {
    setCheckEtsySource && setCheckEtsySource(false);
    setCompleteTutorial && setCompleteTutorial(true);
  };

  return (
    <>
      {checkEtsySource && (
        <Popover id="popover-basic8" className="all-popover" placement="left">
          <Popover.Title as="h3" className="popover-title">
            Synch your Etsy Shop
          </Popover.Title>
          <Popover.Content className="popover-content">
            Connect your Etsy shop to your business to have all your past sales
            automatically inputted into your sales log
          </Popover.Content>
          <Button onClick={handleEtsySource} className="popover-button">
            Finish
          </Button>
        </Popover>
      )}
      <IconContext.Provider value={{ color: "black" }}>
        <nav className="overview-navbar">
          <div className="overview-icon">
            {!isTutorial && (
              <FaIcons.FaBars
                className="sidebar-menu-icon"
                onClick={() => setSidebar && setSidebar(!sidebar)}
                style={{
                  color: isDarkMode ? "#fff" : "#000",
                  cursor: "pointer",
                }}
              />
            )}
            <img
              alt="logo"
              className="logo pointer-cursor"
              src={isDarkMode ? lightLogo : logo}
              onClick={handleLogo}
            />
          </div>
          <LightTooltip
            interactive
            arrow
            PopperProps={{
              modifiers: {
                offset: {
                  enabled: true,
                  offset: "1px 1px",
                },
              },
            }}
            title={
              <div>
                <div className="overview-setting">Settings</div>
                <div className="overview-logout" onClick={handleLogout}>
                  Logout
                </div>
              </div>
            }
          >
            <div className="d-flex justify-align-content-center align-items-center">
              <p className="user-information mr-2">
                {firstName} {lastName.charAt(0)}
              </p>
              <div className="profile-icon">
                {firstName.charAt(0)}
                {lastName.charAt(0)}
              </div>
            </div>
          </LightTooltip>
        </nav>
        <div
          className={
            sidebar
              ? `sidebar-navbar ${classes.closeSidebar}`
              : `sidebar-navbar ${classes.openSidebar}`
          }
        >
          <div className="sidebar-wrap">
            <div className="sidebar-logo">
              <div className="sidebar-icon">
                <FaIcons.FaBars
                  onClick={() => setSidebar && setSidebar(!sidebar)}
                  style={{ color: isDarkMode ? "#fff" : "#000" }}
                />
              </div>
              <img
                alt="logo"
                className="logo"
                src={isDarkMode ? lightLogo : logo}
                onClick={handleLogo}
              />
            </div>
            <Divider />
            <ListItem
              className={cs(
                classes.arrowleft,
                { ["selected-menu"]: location.pathname === "/" },
                { ["selectedDark"]: isDarkMode }
              )}
              button
              component={Link}
              to="/"
              key="Home"
            >
              <ListItemIcon className={classes.homeIcon}>
                <HomePic />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box fontSize={25}>
                    <b>Home</b>
                  </Box>
                }
              />
            </ListItem>
            <Divider />
            <List className="d-flex flex-column">
              {inames.map((text: any, index) => (
                <ListItemButton
                  component={Link}
                  to={{
                    pathname: "/stream/" + text,
                    state: { stream: index },
                  }}
                  className={`${classes.leftspace} ${
                    active === index && "selected-menu"
                  }`}
                  key={text}
                  onClick={() => {
                    setActive(index);
                    setOpen(!open);
                  }}
                >
                  <ListItemText
                    onClick={() => setSidebar && setSidebar(!sidebar)}
                    primary={text}
                  />
                </ListItemButton>
              ))}
            </List>
            <a href="https://forms.gle/C6Qf8aQQqSaD4wvd7">
              <List className={classes.bugLogo}>
                <Divider />
                <ListItem className={classes.arrowleft} button>
                  <ListItemIcon>
                    <BugPic />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box>
                        <b>Feedback</b>
                      </Box>
                    }
                  />
                </ListItem>
              </List>
            </a>
            <Divider />
            <List className={classes.bottomlogout} onClick={handleLogout}>
              <Divider />
              <ListItem className={classes.logout} button>
                <ListItemIcon>
                  <LogoutPic />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Box>
                      <b>Log Out</b>
                    </Box>
                  }
                />
              </ListItem>
            </List>
          </div>
        </div>
      </IconContext.Provider>
    </>
  );
};
export default PermanentDrawerLeft;
